import { RmsAccountSelection } from '@/ui/features/badging/badging-customizations/badge-create/types';
import { ManageBadgesPanelProps } from '@juvare/badging/ui/features/badge-management/ManageBadgesPanel';

export const adjustAccountSelectionChanged: NonNullable<ManageBadgesPanelProps['adjustAccountSelectionChanged']> = (
    accountSelection: RmsAccountSelection,
) => {
    // preselect organization if there is only one
    if (!accountSelection.options.organizationId && accountSelection.account.orgMembership.length === 1) {
        accountSelection.options.organizationId = accountSelection.account.orgMembership[0];
    }

    // preselect occupation if there is only one
    if (!accountSelection.options.occupationId && accountSelection.account.occupationIds?.length === 1) {
        accountSelection.options.occupationId = accountSelection.account.occupationIds[0];
    }

    return accountSelection;
};
